import * as React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { IGridRowModel } from './Utils';
import { Field, FormikProps, FieldInputProps, FieldMetaProps } from 'formik';
import GenericDropdown, { GenericDropdownProps } from '../controls/GenericDropdown';

export const TextColumn = (props: GridCellProps) => {

    const dataItem = props.dataItem as IGridRowModel;

    return <td>
        {dataItem.inEdit &&
            <Field
                component={TextInputComponent}
                name={`items[${props.dataIndex}].${props.field}`}
            />}
        {!dataItem.inEdit && props.dataItem[props.field]}
    </td>
}

export function BooleanColumn(props: GridCellProps) {
    const dataItem = props.dataItem as IGridRowModel;
    return <td>
        {dataItem.inEdit &&
            <Field     
                name={`items[${props.dataIndex}].${props.field}`}
        >          
            {({ field, form, meta }) => <input {...field}
                checked={field.value}
                type="checkbox"
                value={field.value}
                onChange={(e) => {

                    field.onChange(e);
                    
                    if (props.onChange) {
                        props.onChange({
                            dataItem: props.dataItem,
                            syntheticEvent: e,
                            field: props.field,
                            value: !field.value
                        })
                    }
                    
                }}
                className="k-checkbox" />}
            </Field>

        }
        {!dataItem.inEdit && ((props.dataItem[props.field] as boolean)
            ? <span className="k-icon k-i-checkbox-checked"></span>
            : <span className="k-icon k-i-checkbox k-i-shape-rect"></span>)}
    </td>
}

export function DropdownColumn(props: GridCellProps & { dropdown: GenericDropdownProps<any>}) {

    const dataItem = props.dataItem as IGridRowModel;
    return <td style={{ overflow: 'visible' }}>
        {dataItem.inEdit &&
            <Field name={`items[${props.dataIndex}].${props.field}`}>
            {({ field, form, meta }) => <GenericDropdown
                {...props.dropdown}

            />}
            </Field>
        }
        {!dataItem.inEdit && (props.dataItem[props.field] as string)}
    </td>


}

function TextInputComponent({ field, form, ...props }) {
    return <input {...field} {...props} className="k-textbox" />;
};

const CheckboxInputComponent = ({ field, form, ...props }) => {
    return <input {...field} {...props}
        checked={field.value}
        type="checkbox"
        value={field.value}
        className="k-checkbox" />;
};

